import React from "react";
import { ExperimentOutlined } from "@ant-design/icons";

export const buildTestMenuItem = (record, onTest) => ({
  key: "test",
  label: "Test",
  icon: <ExperimentOutlined />,
  onClick: (e) => {
    e.domEvent.preventDefault();
    e.domEvent.stopPropagation();
    onTest(record);
  },
});
